<div class="fx-row align-items-center justify-content-between">
    <div class="fx-column">
        <span class="page-title">{{'ADMIN.TITLE' | translate}}</span>
        <span class="page-subtitle">{{'ADMIN.SUBTITLE' | translate}}</span>
    </div>

</div>
<mat-divider class="mv-20"></mat-divider>
<div class="fx-column fx-wrap justify-content-center">
    <app-organizations class="fx-flex-100"></app-organizations>
    <mat-divider class="mv-20"></mat-divider>
    <app-plans class="fx-flex-100"></app-plans>
</div>
